class BenefitRequestDaysController {
  constructor($scope) {
    'ngInject';
    this.scope=$scope;
  }

  $onInit() {
    this.getDaysDifference();
    this.scope.$watch(()=>this.request,()=>this.getDaysDifference());
  }

  getDaysDifference() {
    this.daysDifference=parseInt(this.request.daysDifference, 10) || 0;
  }

  showEnjoymentDays() {
    return this.daysDifference === 0;
  }

  showPositiveDifferenceDays() {
    return this.daysDifference > 0;
  }

  showNegativeDifferenceDays() {
    return this.daysDifference < 0;
  }
}

export default BenefitRequestDaysController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestDays/benefitRequestDays.controller.js